import React, { useEffect, useState } from "react";

export default function BackToTop() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setShow(window.scrollY > 120);
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!show) return null;

    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="enter fade-in-fast"
            style={{
                position: "fixed",
                bottom: 32,
                right: 32,
                zIndex: 1000
            }}
        >
            ↑ Back to Top
        </button>
    );
}
